import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector, FieldArray, change } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
  FormGroup,
  ControlLabel,
  FormControl,
  Button
} from 'react-bootstrap';
import IncrementButton from '../IncrementButton';
import IncrementBtn from './IncrementBtn';
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import RoomBedsInput from './RoomBedsInput';

import update from './update';
import messages from '../../locale/messages';
import SelectFieldComponent from '../Common/FormField/SelectFieldComponent';

import s from './ListPlaceStep1.css';
import bt from '../../components/commonStyle.css';

class Page3 extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    previousPage: PropTypes.any,
    beds: PropTypes.number,
    nextPage: PropTypes.any,
    bedTypes: PropTypes.array,
    bathrooms: PropTypes.number,
    isExistingList: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      bedType: [],
      beds: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      bedrooms: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      personCapacity: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      bathrooms: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      bathroomType: [],
      useRoomBasedBeds: true,  // Always use room-based UI now
      rooms: [],
      showSharedSpace: false

    }
    this.handleClick = this.handleClick.bind(this);
    this.handleBedroomChange = this.handleBedroomChange.bind(this);
    this.handleRoomBedsChange = this.handleRoomBedsChange.bind(this);
    this.toggleSharedSpace = this.toggleSharedSpace.bind(this);
    this.renderBedroomIncrementButton = this.renderBedroomIncrementButton.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { listingFields, beds, change, bedTypes, bedrooms, rooms: roomsProp } = this.props;
    const { bedType } = this.state;
    let obj, bedsArray = [];

    if (listingFields != undefined) {
      this.setState({
        bedType: listingFields.bedType,
        beds: listingFields.beds[0],
        bedrooms: listingFields.bedrooms[0],
        personCapacity: listingFields.personCapacity[0],
        bathrooms: listingFields.bathrooms[0],
        bathroomType: listingFields.bathroomType,
      });

      // Check if we have existing room data from the database
      if (roomsProp) {
        console.log('[PAGE3_DEBUG] roomsProp:', roomsProp);
        let parsedRooms;
        try {
          parsedRooms = typeof roomsProp === 'string' ? JSON.parse(roomsProp) : roomsProp;
          console.log('[PAGE3_DEBUG] parsedRooms:', parsedRooms);
        } catch (e) {
          console.log('[PAGE3_DEBUG] Failed to parse rooms:', e);
          parsedRooms = null;
        }

        if (parsedRooms && Array.isArray(parsedRooms) && parsedRooms.length > 0) {
          const hasSharedSpace = parsedRooms.some(r => r.roomType === 'shared_space');
          console.log('[PAGE3_DEBUG] Setting state with rooms:', parsedRooms, 'hasSharedSpace:', hasSharedSpace);
          this.setState({
            rooms: parsedRooms,
            useRoomBasedBeds: true,
            showSharedSpace: hasSharedSpace
          });
          return; // Exit early, we have room data
        }
      }

      // Initialize room-based beds if bedrooms > 0 (for new listings)
      // Use bedrooms from props (form value) or fallback to 0
      const bedroomCount = parseInt(bedrooms) || 0;

      if (bedroomCount > 0 && listingFields.bedType && listingFields.bedType.length > 0) {
        const defaultBedType = listingFields.bedType[0].id;
        const rooms = [];

        for (let i = 1; i <= bedroomCount; i++) {
          rooms.push({
            roomNumber: i,
            roomType: 'bedroom',
            beds: [{ bedType: defaultBedType, count: 1 }]
          });
        }

        this.setState({
          rooms,
          useRoomBasedBeds: true
        });

        change('rooms', JSON.stringify(rooms));
        return; // Exit early, don't create flat bedTypes
      }
    }

    // Fallback to old flat bedTypes structure only if bedrooms is 0 or undefined
    if ((bedTypes && beds != bedTypes.length) || (bedTypes && bedTypes.length == 0)) {
      Array(beds).fill().map((i, index) => {
        obj = {
          bedCount: 1,
          bedType: listingFields && listingFields.bedType && listingFields.bedType.length > 0 ? listingFields.bedType[0].id : null,
        };
        bedsArray.push(obj);
      })
      change('bedTypes', bedsArray);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields, rooms: nextRoomsProp } = nextProps;
    const { rooms: currentRoomsProp } = this.props;

    if (listingFields != undefined) {
      this.setState({
        bedType: listingFields.bedType,
        beds: listingFields.beds[0],
        bedrooms: listingFields.bedrooms[0],
        personCapacity: listingFields.personCapacity[0],
        bathrooms: listingFields.bathrooms[0],
        bathroomType: listingFields.bathroomType,
      });
    }

    // Check if rooms prop has changed (new data loaded from backend)
    if (nextRoomsProp && nextRoomsProp !== currentRoomsProp) {
      console.log('[PAGE3_DEBUG] componentWillReceiveProps - roomsProp changed:', nextRoomsProp);
      let parsedRooms;
      try {
        parsedRooms = typeof nextRoomsProp === 'string' ? JSON.parse(nextRoomsProp) : nextRoomsProp;
        console.log('[PAGE3_DEBUG] parsedRooms:', parsedRooms);
      } catch (e) {
        console.log('[PAGE3_DEBUG] Failed to parse rooms:', e);
        parsedRooms = null;
      }

      if (parsedRooms && Array.isArray(parsedRooms) && parsedRooms.length > 0) {
        const hasSharedSpace = parsedRooms.some(r => r.roomType === 'shared_space');
        console.log('[PAGE3_DEBUG] Setting state with rooms:', parsedRooms, 'hasSharedSpace:', hasSharedSpace);
        this.setState({
          rooms: parsedRooms,
          useRoomBasedBeds: true,
          showSharedSpace: hasSharedSpace
        });
      }
    }
  }


  renderIncrementButton = (field) => (
    <IncrementButton
      {...field}
    />
  );

  renderIncrementBtn = (input, dispatch) => (
    <IncrementBtn
      {...input}
      onChange={this.handleClick}
    />
  );


  renderFormControlSelect = ({ input, label, meta: { touched, error }, children, className }) => {
    return (
      <div>
        <FormControl componentClass="select" {...input} className={className} >
          {children}
        </FormControl>
      </div>
    )
  }

  renderBedTypes = ({ fields, meta: { error, submitFailed } }) => {
    const { bedType } = this.state;
    let bedTypeValue = [];

    bedType && bedType.map((item, key) => {
      if (item.isEnable == 1) {
        bedTypeValue.push({
          value: item?.id,
          label: item?.itemName
        })
      }
    })
    return (
      <div className={s.spaceTop2}>
        {
          fields.map((beds, index) => (

            <div key={index}>
              <FormGroup className={s.space5}>
                <Field
                  name={`${beds}.bedType`}
                  type="text"
                  component={SelectFieldComponent}
                  inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                  options={bedTypeValue}
                />

              </FormGroup>
            </div>
          ))
        }
      </div>
    )
  }

  async handleClick(e) {
    const { beds, bedTypes, change } = this.props;
    const { bedType } = this.state;

    let bedTypesValue = Object.keys(bedTypes).map(function (key) {
      return bedTypes[key];
    });

    let updatedBedTypesArray = (bedTypesValue && bedTypesValue.length > 0) ? bedTypesValue.slice(0) : [];
    let updatedBedCount = beds + 1;
    let obj = {};

    if (Number(beds) < Number(e)) {
      obj = {
        bedCount: updatedBedCount,
        bedType: bedType.length > 0 ? bedType[0].id : null,
      };
      try {
        updatedBedTypesArray.push(obj);
      } catch (e) {

      }
    } else if ((Number(beds) >= Number(e)) || (Number(e) > 2)) {
      updatedBedTypesArray.splice(bedTypesValue.length - 1, 1);
    }

    await change('bedTypes', []);
    await change('bedTypes', updatedBedTypesArray);
  }

  handleBedroomChange(bedroomCount) {
    const { bedType, rooms: currentRooms } = this.state;
    const { change } = this.props;

    const defaultBedType = bedType.length > 0 ? bedType[0].id : null;
    const newRooms = [];

    // Preserve existing bedroom configurations or create new ones
    for (let i = 1; i <= bedroomCount; i++) {
      const existingRoom = currentRooms.find(r => r.roomNumber === i && r.roomType === 'bedroom');

      if (existingRoom) {
        // Keep existing room configuration
        newRooms.push(existingRoom);
      } else {
        // Create new room with default
        newRooms.push({
          roomNumber: i,
          roomType: 'bedroom',
          beds: [{ bedType: defaultBedType, count: 1 }]
        });
      }
    }

    // Preserve shared spaces
    const sharedSpaces = currentRooms.filter(r => r.roomType === 'shared_space');
    const allRooms = [...newRooms, ...sharedSpaces];

    this.setState({
      rooms: allRooms,
      useRoomBasedBeds: bedroomCount > 0
    });

    // Update redux form
    change('rooms', JSON.stringify(allRooms));
  }

  handleRoomBedsChange(roomNumber, roomType, updatedBeds) {
    const { rooms = [] } = this.state;
    const { change } = this.props;

    // Find and update the specific room by roomNumber and roomType
    const updatedRooms = rooms.map(room => {
      if (room.roomNumber === roomNumber && room.roomType === roomType) {
        return {
          ...room,
          beds: updatedBeds
        };
      }
      return room;
    });

    // If room doesn't exist in state, add it
    const roomExists = rooms.some(r => r.roomNumber === roomNumber && r.roomType === roomType);
    if (!roomExists) {
      updatedRooms.push({
        roomNumber,
        roomType,
        beds: updatedBeds
      });
    }

    this.setState({ rooms: updatedRooms });
    change('rooms', JSON.stringify(updatedRooms));

    // Calculate total beds
    const totalBeds = updatedRooms.reduce((total, room) => {
      const beds = room?.beds || [];
      return total + beds.reduce((sum, bed) => sum + (bed.count || 1), 0);
    }, 0);
    change('beds', totalBeds);
  }

  toggleSharedSpace() {
    const { rooms, showSharedSpace, bedType } = this.state;
    const { change } = this.props;
    const defaultBedType = bedType.length > 0 ? bedType[0].id : null;

    let updatedRooms = [...rooms];

    if (!showSharedSpace) {
      // Add shared space
      updatedRooms.push({
        roomNumber: 0,
        roomType: 'shared_space',
        beds: [{ bedType: defaultBedType, count: 1 }]
      });
    } else {
      // Remove shared space
      updatedRooms = updatedRooms.filter(room => room.roomType !== 'shared_space');
    }

    this.setState({
      rooms: updatedRooms,
      showSharedSpace: !showSharedSpace
    });

    change('rooms', JSON.stringify(updatedRooms));

    // Recalculate total beds
    const totalBeds = updatedRooms.reduce((total, room) => {
      return total + room.beds.reduce((sum, bed) => sum + (bed.count || 1), 0);
    }, 0);
    change('beds', totalBeds);
  }

  renderBedroomIncrementButton = (field) => {
    const { input } = field;
    const originalOnChange = input.onChange;

    return (
      <IncrementButton
        {...field}
        input={{
          ...input,
          onChange: (value) => {
            originalOnChange(value);
            // Trigger room creation when bedrooms change
            if (value > 0) {
              setTimeout(() => this.handleBedroomChange(value), 0);
            } else {
              // Clear rooms if bedrooms is 0
              this.setState({ rooms: [], useRoomBasedBeds: false });
            }
          }
        }}
      />
    );
  };

  render() {
    const { handleSubmit, previousPage, nextPage, isExistingList, formPage, step, bedrooms: bedroomsProp } = this.props;
    const { formatMessage } = this.props.intl;
    const { bedrooms, beds, personCapacity, bathrooms, bathroomType, bedType, rooms, useRoomBasedBeds, showSharedSpace } = this.state;

    // Ensure rooms array matches bedroom count
    const bedroomCount = parseInt(bedroomsProp) || 0;
    let displayRooms = rooms;

    // If rooms array doesn't match bedroom count, generate on the fly for display
    // Count only bedrooms (not shared spaces)
    const bedroomRoomsCount = rooms.filter(r => r.roomType === 'bedroom').length;

    if (bedroomCount > 0 && bedroomRoomsCount !== bedroomCount) {
      const defaultBedType = bedType.length > 0 ? bedType[0].id : null;
      const newRooms = [];

      // Add bedroom rooms
      for (let i = 1; i <= bedroomCount; i++) {
        newRooms.push({
          roomNumber: i,
          roomType: 'bedroom',
          beds: [{ bedType: defaultBedType, count: 1 }]
        });
      }

      // Preserve shared spaces if any
      const sharedSpaces = rooms.filter(r => r.roomType === 'shared_space');
      displayRooms = [...newRooms, ...sharedSpaces];
    }

    let bathroomTypeValue = [];
    let bedTypeOptions = [];
    // let path = isExistingList ? "map" : "location";
    let path = "location";

    bathroomType && bathroomType.map((item, key) => {
      if (item.isEnable == 1) {
        bathroomTypeValue.push({
          value: item?.id,
          label: item?.itemName
        })
      }
    })

    bedType && bedType.map((item, key) => {
      if (item.isEnable == 1) {
        bedTypeOptions.push({
          value: item?.id,
          label: item?.itemName
        })
      }
    })

    return (
      <div className={cx(s.grid, 'arrowPosition')}>
        <SidePanel
          title={formatMessage(messages.stepOneCommonHeading)}
          landingContent={formatMessage(messages.howManyGuests)}
        />
        <form onSubmit={handleSubmit}>
          <div className={s.landingMainContent}>
            <FormGroup className={s.space5}>
              <ControlLabel className={cx(s.landingLabel)}>
                <FormattedMessage {...messages.totalGuests} />
              </ControlLabel>
              <Field
                name="personCapacity"
                type="text"
                component={this.renderIncrementButton}
                labelSingluar={personCapacity.itemName}
                labelPlural={personCapacity.otherItemName}
                maxValue={personCapacity.endValue}
                minValue={personCapacity.startValue}
                incrementBy={1}
              />
            </FormGroup>
            <FormGroup className={s.space5}>
              <ControlLabel className={cx(s.landingLabel)}>
                <FormattedMessage {...messages.howManyBedrooms} />
              </ControlLabel>
              <Field
                name="bedrooms"
                type="text"
                component={this.renderBedroomIncrementButton}
                labelSingluar={bedrooms.itemName}
                labelPlural={bedrooms.otherItemName}
                minValue={bedrooms.startValue}
                incrementBy={1}
                maxValue={bedrooms.endValue}
              />
            </FormGroup>

            {/* Room-based bed configuration */}
            {useRoomBasedBeds && bedroomsProp > 0 && (
              <div className={s.space5} style={{ marginTop: '30px', paddingTop: '30px', borderTop: '1px solid #dce0e0' }}>
                {/* Header with Total Beds */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                  <h4 className={cx(s.landingLabel)} style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>
                    <FormattedMessage {...messages.bedsPerRoom} />
                  </h4>
                  <Field
                    name="beds"
                    type="text"
                    component={({ input }) => (
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#484848' }}>
                        <FormattedMessage {...messages.totalBeds} />: <span style={{ fontSize: '18px', color: '#008489' }}>{input.value || 0}</span>
                      </div>
                    )}
                  />
                </div>

                <div className={s.space4}>
                  {displayRooms.map((room, index) => (
                    room.roomType === 'bedroom' && (
                      <RoomBedsInput
                        key={index}
                        roomNumber={room.roomNumber}
                        roomType={room.roomType}
                        beds={room.beds}
                        bedTypeOptions={bedTypeOptions}
                        onChange={(updatedBeds) => this.handleRoomBedsChange(room.roomNumber, room.roomType, updatedBeds)}
                      />
                    )
                  ))}
                </div>

                {/* Shared Space Toggle */}
                <div className={s.space4}>
                  <Button
                    className={cx(bt.btnPrimaryBorder)}
                    onClick={this.toggleSharedSpace}
                  >
                    {showSharedSpace ? (
                      <FormattedMessage {...messages.removeSharedSpace} />
                    ) : (
                      <FormattedMessage {...messages.addSharedSpace} />
                    )}
                  </Button>
                </div>

                {/* Shared Space Configuration */}
                <div className={s.space4}>
                  {displayRooms.map((room, index) => (
                    room.roomType === 'shared_space' && (
                      <RoomBedsInput
                        key={index}
                        roomNumber={room.roomNumber}
                        roomType={room.roomType}
                        beds={room.beds}
                        bedTypeOptions={bedTypeOptions}
                        onChange={(updatedBeds) => this.handleRoomBedsChange(room.roomNumber, room.roomType, updatedBeds)}
                      />
                    )
                  ))}
                </div>
              </div>
            )}

            <FormGroup className={s.space5}>
              <ControlLabel className={cx(s.landingLabel)}>
                <FormattedMessage {...messages.howManyBathrooms} />
              </ControlLabel>
              <Field
                name="bathrooms"
                type="text"
                component={this.renderIncrementButton}
                labelSingluar={bathrooms.itemName}
                labelPlural={bathrooms.otherItemName}
                maxValue={bathrooms.endValue}
                minValue={bathrooms.startValue}
                incrementBy={0.5}
              />
            </FormGroup>

            <FormGroup className={s.formGroup}>
              <Field name="bathroomType"
                component={SelectFieldComponent}
                inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                options={bathroomTypeValue}
              />
            </FormGroup>
          </div>
          <FooterButton
            nextPage={nextPage}
            previousPage={previousPage}
            nextPagePath={path}
            previousPagePath={"room"}
            formPage={formPage}
            step={step}
          />
        </form>
      </div>
    )
  }
}


Page3 = reduxForm({
  form: 'ListPlaceStep1', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmit: update
})(Page3);

// Decorate with connect to read form values
const selector = formValueSelector('ListPlaceStep1'); // <-- same as form name

const mapState = (state) => ({
  isExistingList: state.location.isExistingList,
  listingFields: state.listingFields.data,
  beds: selector(state, 'beds'),
  bedCount: selector(state, 'beds'),
  bedTypes: selector(state, 'bedTypes'),
  bedrooms: selector(state, 'bedrooms'),
  rooms: selector(state, 'rooms'),
});

const mapDispatch = {
  change,
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Page3)));